import React from "react";
import { Box, Button } from "@mui/material";
import { warm } from "../../../style/color";
import packageJson from "../../../../package.json";

export const Links: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          color: warm[900],
          flexGrow: 1,
          display: {
            xs: "flex-column",
            sm: "flex",
          },
          justifyContent: {
            xs: "center",
            sm: "center",
            lg: "flex-end"
          },
        }}
      >
        <Button href="/policy" target="_blank" variant="footer"
        sx={{
          px: {
            xs: 0,
            sm: 1,
          },
        }}
        >
          Privacy Policy
        </Button>

        <Button variant="footer"
        sx={{
          px: {
            xs: 0,
            sm: 1,
          },
        }}
        >
          Terms & conditions</Button>

        <Button disabled variant="footer"
        sx={{
          px: {
            xs: 0,
            sm: 1,
          },
        }}
        >
          Version {packageJson.version}
        </Button>
      </Box>
    </>
  );
};
export default Links;
